// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitSpecialDetail extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodePeopleArr: cc.Node = null;

    @property(cc.Prefab)
    nodeItem: cc.Prefab = null;

    @property(cc.Label)
    labelDesc: cc.Label = null;

    @property(cc.Node)
    nodeList: cc.Node = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    private bCanClick = false;
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

        this.initLayer();
    }

    initLayer() {
        let csvInfo = this._carryData.csvInfo;
        let peopleArr = this._carryData.peopleArr;
        this.labelDesc.string = csvInfo.desc;
        utilsView.refreshLabelUI(this.labelDesc);
        this.scrollView.content.height = this.labelDesc.node.height;

        
        for (let i = 0; i < peopleArr.length; i++) {
            let item = cc.instantiate(this.nodeItem);
            let itemScript = item.getComponent(BaseComponent);
            itemScript.setCarryData({
                id: peopleArr[i]
                , idx: i
                , parent: this
            });
            this.nodeList.addChild(item);
        }   
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // this.destroyNode();
        this.setShow(false);
        if (!this._carryData.bCanClick) {
            this._carryData.parent.setBtnDetailAni(true);
        }
    }

    setShow(visible: boolean) {
        this.node.active = visible;
    }

    setCanClick(bClick: boolean) {
        this.bCanClick = bClick;

        this.nodePeopleArr.active = bClick;
        this.scrollView.node.height = bClick ? 379 : 736;
    }

    onClickSelect(idx: number) {
        if (!this.bCanClick) {
            return;
        }
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // this.onClickClose();
        this.setShow(false);
        this._carryData.parent.onClickSelect(idx);
    }

    // update (dt) {}
}
